module.exports = __webpack_public_path__ + "img/quick-nav-mpg.0f84bf0b.png";